/*
 * @Author: cgh
 * @Date: 2022-08-01 10:50:50
 * @LastEditors: cgh
 * @LastEditTime: 2022-08-02 17:15:02
 * @Description: 问题列表管理
 */

const wtlbRoutes = {
  path: 'wtlb',
  name: 'jxxfWtlb',
  component: { template: '<router-view></router-view>' },
  children: [
    {
      path: 'list',
      name: 'jxxfWtlbManage',
      component: () => import(/* webpackChunkName: "wtlbManageList" */ '@/features/jxxf/pg/wtlb/list.vue'),
      meta: {
        navtabTitle: '问题列表管理',
        isCache: true,
        ignoreDiff: [],
        isSecondary: false
      }
    },
    {
      path: 'list/:xmId',
      name: 'jxxfWtlbProjectManage',
      component: () => import(/* webpackChunkName: "wtlbManageList" */ '@/features/jxxf/pg/wtlb/list.vue'),
      meta: {
        navtabTitle: '问题列表管理',
        isCache: true,
        ignoreDiff: [],
        isSecondary: false
      }
    }
  ]
};

export default wtlbRoutes;
